import { useSelector } from 'react-redux';
import { useHoneypotContext } from './HoneypotContext';
import { getCurrentStep } from '../store/flow/selectors';
import { useTracker } from '../tracking/useTracker';
import { useState } from 'react';
import { getHoneypotConfig } from './config';
export const useHoneypots = () => {
  var _ctx$honeypots$curren;
  const {
    DISABLE_HONEYPOTS
  } = getHoneypotConfig();
  const [hasTracked, setHasTracked] = useState(false);
  const ctx = useHoneypotContext();
  const Tracker = useTracker();
  const currentStep = useSelector(getCurrentStep);
  const trackHoneypotInteraction = () => {
    if (!hasTracked) {
      setHasTracked(true);
      Tracker.signupInteraction('honeypotInteraction');
    }
  };
  if (DISABLE_HONEYPOTS) {
    return {
      honeypots: [],
      trackHoneypotInteraction: () => {}
    };
  }
  if (!currentStep) {
    return {
      honeypots: [],
      trackHoneypotInteraction: () => {}
    };
  }
  return {
    honeypots: (_ctx$honeypots$curren = ctx.honeypots[currentStep]) !== null && _ctx$honeypots$curren !== void 0 ? _ctx$honeypots$curren : [],
    trackHoneypotInteraction
  };
};